export { default } from './DialogBody';
export * from './DialogBody';
